import { mapKeys } from 'lodash'
import { AppSpecData, ViewerClientSpecMap } from '@wix/thunderbolt-symbols'
import {
	Component,
	Data,
	DataMap,
	InternalRefDataItem,
	Structure,
	WidgetRefDataItem,
} from '@wix/thunderbolt-becky-types'

export const BuilderComponentType = 'BuilderComponent'

export const getBuilderComponentUrl = (app: AppSpecData, widgetId: string): string => {
	const widget = app?.widgets ? app?.widgets[widgetId] : {}
	// @ts-ignore
	return widget?.componentFields?.appStudioFields?.componentModel?.componentUrl
}

export const isBuilderComponent = (app: AppSpecData, widgetId: string): boolean =>
	!!getBuilderComponentUrl(app, widgetId)

const removeHash = (value: string) => value && value.replace('#', '')

const getCompAppData = (comp: Component, documentData: DataMap) => {
	const dataQuery = removeHash(comp.dataQuery || '')
	return documentData[dataQuery] as WidgetRefDataItem | InternalRefDataItem
}

const structureFixer = (
	structure: Structure,
	documentData: any,
	csm: ViewerClientSpecMap,
	builderWidgetsIds: Record<string, string>
) => {
	for (const compId in structure) {
		const comp = structure[compId]
		if (comp.componentType.endsWith('RefComponent')) {
			const compAppData = getCompAppData(comp, documentData)

			if (compAppData.type === 'WidgetRef') {
				const { appDefinitionId, widgetId } = compAppData
				const app = csm[appDefinitionId]
				if (!!builderWidgetsIds[widgetId] || isBuilderComponent(app, widgetId)) {
					structure[compId].componentType = BuilderComponentType
				}
			} else {
				const { pageId } = compAppData
				if (pageId && builderWidgetsIds[pageId]) {
					structure[compId].componentType = BuilderComponentType
				}
			}
		}
	}
	return structure
}

export const fixBuilderComponentType = ({
	masterPageStructure,
	structure,
	data: { document_data: documentData },
	clientSpecMap,
	builderWidgetsIds,
}: {
	masterPageStructure: Structure
	structure: Structure
	data: Data
	clientSpecMap: ViewerClientSpecMap
	builderWidgetsIds: Record<string, string>
}) => {
	const csmByAppDefId = mapKeys(clientSpecMap, (app) => app.appDefinitionId)

	return {
		masterPageStructure: structureFixer(masterPageStructure, documentData, csmByAppDefId, builderWidgetsIds),
		structure: structureFixer(structure, documentData, csmByAppDefId, builderWidgetsIds),
	}
}
